import axios from './axios.interceptors';
import {SeatClassRequest, SeatClassResponse, PagedSeatClassesList, SeatClassStatus, SeatClassStatusUpdateResponse} from 'app/types/service-types/AircraftTypes';

interface GetAllSeatClassesParams {
  status?: SeatClassStatus;
  page?: number;
  size?: number;
  sort?: string;
}

class SeatClassService {

  public getAll = async (params?: GetAllSeatClassesParams | SeatClassStatus): Promise<PagedSeatClassesList | SeatClassResponse[]> => {
    try {
      let url = '/api/seat-classes';
      const queryParams: string[] = [];
      
      // Handle legacy calls where status is passed directly as string
      if (typeof params === 'string') {
        queryParams.push(`status=${params}`);
        queryParams.push(`size=9999`); // Large size for non-paginated calls
      } else if (params) {
        if (params.status) queryParams.push(`status=${params.status}`);
        if (params.page !== undefined) queryParams.push(`page=${params.page}`);
        if (params.size !== undefined) queryParams.push(`size=${params.size}`);
        if (params.sort) queryParams.push(`sort=${params.sort}`);
      }
      
      if (queryParams.length > 0) {
        url += '?' + queryParams.join('&');
      }
      
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  public getById = async (id: string): Promise<SeatClassResponse> => {
    try {
      const response = await axios.get(`/api/seat-classes/${id}`);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  public create = async (body: SeatClassRequest): Promise<any> => {
    try {
      const response = await axios.post('/api/seat-classes', body);
      return response;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  public update = async (id: string, body: SeatClassRequest): Promise<any> => {
    try {
      const response = await axios.put(`/api/seat-classes/${id}`, body);
      return response;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }

  public updateStatus = async (id: string, status: SeatClassStatus): Promise<SeatClassStatusUpdateResponse> => {
    try {
      const response = await axios.patch(`/api/seat-classes/${id}/status?status=${status}`);
      return response.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
}

export default new SeatClassService();
